import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function loggedInUserReducer(state = initialState.loggedInUser, action) {
  let content = { ...state };

  switch (action.type) {
    case types.GET_LOGGED_IN_USER_SUCCESS: {
      return { ...state, ...action.user };
    }

    case types.GET_LOGGED_IN_USER_ERROR: {
      content.notLoggedIn = true;
      return content;
    }

    case types.GET_USER_LOCATION_SUCCESS: {
      // We only ever want to use this data if the user isn't logged in (to work out plan prices)
      // If a user is logged in then we should use the values from the /user API instead as Stripe
      // cannot deal with changes in currency on same user
      if (!(`id` in state)) {
        content = { ...state, ...action.data };
        return content;
      }
      return state;
    }

    case types.IS_USER_COACH_SUCCESS:
      content.isCoach = action.bool;
      return content;

    case types.IS_USER_PLAYER_SUCCESS:
      content.isPlayer = action.bool;
      return content;

    case types.GET_USER_SIGNUP_DETAILS_SUCCESS: {
      const combined = { ...state, ...action.data };
      return combined;
    }

    case types.UPDATE_EMAIL_SUCCESS:
      content.email_address = action.newEmail;
      return content;

    case types.UPDATE_PHONE_NUMBER_SUCCESS:
      content.area_no_1 = action.areaNo1;
      content.area_code_1 = action.areaCode1;
      content.tel_no_1 = action.telNo1;
      return content;

    case types.UPDATE_EMAIL_PREFERENCES_SUCCESS:
      content.email_preferences = action.emailPreferences;
      return content;

    case types.UPDATE_COACH_AGE_PREFERENCES_SUCCESS:
      content.ages = action.agePreferences;
      return content;

    case types.GET_ACCOUNT_DETAILS_SUCCESS: {
      const { ages, ...dataWithoutAges } = action.data;
      const combined = { ...state, ...dataWithoutAges };
      combined.age_groupings = action.data.ages;
      return combined;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/userReducer.js